<template>
  <aside class="panel">
    <div class="panel__glow" />

    <div class="panel__intro">
      <p class="panel__overline">
        {{ $t('signup.v2.panel.overline') }}
      </p>
      <h2 class="text-h4 font-weight-medium panel__heading">
        {{ $t('signup.v2.panel.heading-1') }}<br class="panel__break" />{{
          $t('signup.v2.panel.heading-2')
        }}
      </h2>
    </div>

    <ul class="panel__list">
      <li
        v-for="feature in features"
        :key="feature"
        class="d-flex ga-4"
      >
        <v-avatar
          color="petrol"
          size="32"
        >
          <v-icon
            icon="mdi-check"
            size="18"
          />
        </v-avatar>
        <div class="d-flex flex-column ga-1">
          <strong class="text-subtitle-1 font-weight-medium">{{
            $t(`signup.v2.panel.features.${feature}.title`)
          }}</strong>
          <span class="text-body-1 panel__desc">{{
            $t(`signup.v2.panel.features.${feature}.text`)
          }}</span>
        </div>
      </li>
    </ul>
  </aside>
</template>

<script setup lang="ts">
const features = ['content', 'leads', 'follow-up', 'growth'] as const
</script>

<style scoped>
.panel {
  position: relative;
  width: 514px;
  max-width: 100%;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 60px 50px;
  border-radius: 10px;
  background: rgb(var(--v-theme-on-surface));
  color: #fff;
}

.panel__glow {
  position: absolute;
  left: 205px;
  top: 6px;
  width: 297px;
  height: 297px;
  border-radius: 50%;
  background: rgb(var(--v-theme-petrol, 27, 145, 133));
  opacity: 0.35;
  filter: blur(73px);
  pointer-events: none;
}

.panel__intro {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.panel__overline {
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 1.3px;
  text-transform: uppercase;
  color: rgb(var(--v-theme-hell-turkis, 135, 229, 211));
}

.panel__list {
  position: relative;
  list-style: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.panel__desc {
  opacity: 0.85;
}

@media (max-width: 599px) {
  .panel {
    width: 100%;
    border-radius: 0;
    padding: 20px 12px;
    gap: 12px;
  }

  .panel__intro {
    gap: 4px;
  }
  .panel__overline {
    font-size: 10px;
    letter-spacing: 1px;
  }

  .panel__heading {
    font-size: 22px !important;
    line-height: 28px !important;
  }
  .panel__break {
    display: none;
  }
  .panel__heading::after {
    content: '';
  }

  .panel__list {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px 12px;
  }
  .panel__list li {
    align-items: center;
    gap: 8px;
  }
  .panel__list .v-avatar {
    width: 20px !important;
    height: 20px !important;
  }
  .panel__list .v-icon {
    font-size: 12px !important;
  }
  .panel__list strong {
    font-size: 12px;
    line-height: 16px;
    font-weight: 500;
  }
  .panel__desc {
    display: none;
  }

  .panel__glow {
    left: auto;
    right: -80px;
    top: -60px;
  }
}
</style>
